import { Refine, Authenticated } from '@refinedev/core';
import routerProvider, {
  CatchAllNavigate,
  NavigateToResource,
} from '@refinedev/react-router-v6';
import { BrowserRouter, Outlet, Route, Routes } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AppShell } from './components/layout/app-shell';
import { authProvider } from './lib/auth-provider';
import { dataProvider } from './lib/data-provider';
import { DashboardPage } from './pages/dashboard';
import { LoginPage } from './pages/login';
import { AuditListPage } from './pages/audit/list';
import { PurchaseQueuePage } from './pages/purchase-queue/list';
import { PsnAccountCreatePage } from './pages/psn-accounts/create';
import { PsnAccountDetailPage } from './pages/psn-accounts/detail';
import { PsnAccountsListPage } from './pages/psn-accounts/list';
import { TopupCreatePage } from './pages/topup/create';
import { TopupListPage } from './pages/topup/list';

export function App() {
  return (
    <BrowserRouter>
      <Refine
        dataProvider={dataProvider}
        authProvider={authProvider}
        routerProvider={routerProvider}
        resources={[
          { name: 'psn-accounts', list: '/contas', show: '/contas/:id' },
          { name: 'topup', list: '/topup', create: '/topup/new' },
          { name: 'audit-log', list: '/audit' },
        ]}
        options={{
          syncWithLocation: true,
          warnWhenUnsavedChanges: true,
          disableTelemetry: true,
        }}
      >
        <Routes>
          <Route
            element={
              <Authenticated key="protected" fallback={<CatchAllNavigate to="/login" />}>
                <AppShell>
                  <Outlet />
                </AppShell>
              </Authenticated>
            }
          >
            {/* Q-246: home = Fila de Compras; Dashboard movido pra /visao-geral */}
            <Route index element={<PurchaseQueuePage />} />
            <Route path="/visao-geral" element={<DashboardPage />} />
            <Route path="/contas" element={<PsnAccountsListPage />} />
            <Route path="/contas/new" element={<PsnAccountCreatePage />} />
            <Route path="/contas/:id" element={<PsnAccountDetailPage />} />
            <Route path="/topup" element={<TopupListPage />} />
            <Route path="/topup/new" element={<TopupCreatePage />} />
            <Route path="/audit" element={<AuditListPage />} />
          </Route>
          <Route
            element={
              <Authenticated key="public" fallback={<Outlet />}>
                <NavigateToResource resource="psn-accounts" />
              </Authenticated>
            }
          >
            <Route path="/login" element={<LoginPage />} />
          </Route>
        </Routes>
      </Refine>
      <Toaster position="top-right" theme="dark" richColors />
    </BrowserRouter>
  );
}
